<template>
  <section
    v-if="jewel.description"
    class="extra-description-wrapper"
  >
    <div class="extra-description">
      <h2>Описание изделия</h2>
      <div
        class="user-description"
        v-html="jewel.description"
        itemprop="description"
      ></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CatalogJewelArticleExtraDescription',
  props: ['jewel'],
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .extra-description-wrapper {
    background-color: $inverse-background-color;
    flex-basis: 100%;
    @include vertical-breakpoint-padding("tablet", 4em, 3em);

    & > .extra-description {
      @include centered-block-width($big-tablet: 60%);

      h2 {
        color: $inverse-text-color;
        border-top: 1px solid $inverse-text-color;
        border-bottom: 1px solid $inverse-text-color;
        padding: 0.5em;
      }

      & > .user-description {
        color: $inverse-text-color;
        text-align: justify;

        & >>> ul {
          padding-left: 1em;
          list-style-type: disc;
          li { display: list-item; }
        }
        & >>> a {
          font-weight: bold;
          color: $inverse-text-color;
          &:hover { color: $default-text-color; }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-article/CatalogJewelArticleExtraDescription.vue